import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const NumberOfSMCMeetingsConducted = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Number of SMC meetings conducted" />
    </Box>
  );
};
